//#region Styles
import { 
    Header, Title, 
    HeaderTop } from "./styles";
//#endregion
//#region Components
import DropDownButton from "components/DropDownButton/DropDownButton";
//#endregion
//#region Utils
import Filters from "./components/Filters/Filters";
import { CREATE_ACAD_REINFORCE_DROPDOWN_OPTIONS } from "../../utils/constants";
//#endregion

const ListHeader = ({
    isTutorUser, data, loadingRequest,
    filters, resetUI, triggerFillAcadReinforceList,
    paginator, currentTabIdx, inSyncOfAcadReinforceUnprocessed
}) => {
    return (
        <Header>
            <HeaderTop>
                <Title>Refuerzos</Title>
                {!isTutorUser && 
                    <DropDownButton 
                        text="Crear refuerzo" 
                        items={CREATE_ACAD_REINFORCE_DROPDOWN_OPTIONS}/>}
            </HeaderTop>
            <Filters 
                isTutorUser={isTutorUser}
                loadingRequest={loadingRequest}
                data={data}
                filters={filters}
                currentTabIdx={currentTabIdx}
                paginator={paginator}
                resetUI={resetUI}
                triggerFillAcadReinforceList={triggerFillAcadReinforceList}
                disabled={inSyncOfAcadReinforceUnprocessed}/>
        </Header>
    );
}

export default ListHeader;